import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Button from 'react-bootstrap/Button'
import axios from 'axios';
import Swal from 'sweetalert2'
import * as myConstClass from '../../constantes.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons'
import { faTrashCan } from '@fortawesome/free-solid-svg-icons'

export default function List() {

    const [datosTabla, setDatosTabla] = useState([])

    useEffect(()=>{
        fetchProducts() 
    },[])

    const fetchProducts = async () => {
        await axios.get(`${myConstClass.URL_APP}/api/${myConstClass.VAR_GLOBAL.baseprincipal}/mantenedor/tipopago`).then(({data})=>{
            setDatosTabla(data)
        })
    }

    const deleteProduct = async (id) => {
        const isConfirm = await Swal.fire({
            title: 'Desea continuar?',
            text: "Esta accion no puede ser revertida",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, eliminar.'
          }).then((result) => {
            return result.isConfirmed
          });

          if(!isConfirm){
            return;
          }

          await axios.delete(`${myConstClass.URL_APP}/api/${myConstClass.VAR_GLOBAL.baseprincipal}/products/${id}`).then(({data})=>{
            Swal.fire({
                icon:"success",
                text:data.message
            })
            fetchProducts()
          }).catch(({response:{data}})=>{
            Swal.fire({
                text:data.message,
                icon:"error"
            })
          })
    }

    return (
      <div className="container">        
            <h4 className="text-center">Tipos de pago</h4>        
            <hr />
          <div className="row">
            <div className='col-12'>
                <Link className='btn btn-primary mb-2 float-end' to={"/tipopago/create"}>
                    Nuevo
                </Link>
            </div>
            <div className="col-12">
                <div className="card card-body">
                    <div className="table-responsive">
                        <table className="table table-bordered mb-0 text-center">
                            <thead>
                                <tr>
                                    <th>Nombre</th>
                                    <th>Imagen Validación</th>
                                    <th>Notificar alerta</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    datosTabla.length > 0 && (
                                        datosTabla.map((row, key)=>(
                                            <tr key={key}>
                                                <td className="text-start">{row.descripcion}</td>
                                                <td>{row.validacion_imagen === "1" ? "SI" : "NO" }</td>
                                                <td>{row.notificacion_alerta === "1" ? "SI" : "NO" }</td>
                                                <td>
                                                    <Link to={`/tipopago/edit/${row.id}`} className='btn btn-success btn-sm me-2' >
                                                        <FontAwesomeIcon icon={faPenToSquare}/>
                                                    </Link>
                                                    <Button variant="danger" className="btn-sm" onClick={()=>deleteProduct(row.id)}>
                                                        <FontAwesomeIcon icon={faTrashCan}/>
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))
                                    )
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
          </div>
      </div>
    )
}
